import React from 'react'

import StaticScene from '../StaticScene/StaticScene'

import SnapImage from '../../assets/images/snap.svg'

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true })
    if (window.Raven) {
      window.Raven.captureException(error, { extra: info })
    } else {
      console.error(error, { extra: info })
    }
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI
      return (
        <StaticScene>
          <div className="text-center">
            <img alt="Snap!" className="mt-5" src={SnapImage} width={100} />
            <h1>We're sorry - something's gone wrong</h1>
            {window.Raven && (
              <React.Fragment>
                <p>
                  Our team has been notified. If you have a minute, please
                  report the issue and tell us what you were doing. Thank you
                  and we apologize for any inconvenience caused.
                </p>
                <button
                  className="btn btn-primary mb-5"
                  onClick={() =>
                    window.Raven.lastEventId() &&
                    window.Raven.showReportDialog()
                  }
                >
                  Report issue
                </button>
              </React.Fragment>
            )}
          </div>
        </StaticScene>
      )
    }

    return this.props.children // No error? Render children
  }
}



// WEBPACK FOOTER //
// ./src/components/AppErrorBoundary/AppErrorBoundary.js